<template>
  <div class="Trainee-modal-overlay">
    <transition name="modal-expand">
      <div v-if="isVisible" class="Trainee-modal" @click.stop>
        <div class="modal-content">
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <div class="search-container">
            <h3 style="font-size: 1.5rem; margin-bottom: 10px;">{{ isEditing ? 'Edit Group of Trainees' : 'Create Group of Trainees' }}</h3>
            <!-- <input type="text" style="width: 40%;" v-model="searchQuery" placeholder="Search by Name" /> -->
          </div>
          <div class="group-name-container">
            <label for="groupName" style="margin-right: 20px;">Group Name</label>
            <input id="groupName" type="text" style="width: 40%; margin-bottom: 10px;" v-model="groupName"
              placeholder="Enter group name" />
          </div>
          <div class="action-bar" style="margin-bottom: 10px;">
            <button class="multi-sign-off-button" @click="clearSelection" style="margin-left: 10px;">
              Clear Selection
            </button>
            <button class="multi-sign-off-button" @click="selectAllTrainees">Select All</button>
          </div>
          <div class="container-fluid">
            <vue-good-table 
              :columns="columns" :rows="filteredTrainees"
              :pagination-options="{ enabled: true, perPage: perPage }" :search-options="{ enabled: false }"
              :sort-options="{ enabled: true }">
              <template #table-row="props">
                <span v-if="props.column.field === 'select'">
                  <input type="checkbox" v-model="selectedTrainees" :value="props.row.user_id" @click.stop>
                </span>

                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>

          </div>
          <div class="button-container">
            <button class="ins-close-button" @click="close()">Close</button>
            <button class="btn btn-primary rounded" @click="confirmSelectionWithGroup()">{{ isEditing ? 'Update Group' :
              'Save Group' }}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';


export default {
  name: 'SelectGroupTraineesModal',
  components: {
    VueGoodTable,
  },
  props: {
    propTrainees: {
      type: Array,
      required: true,
    },
    initialSelected: {
      type: Array,
      required: true,
    },
    propGroups: {
      type: Array,
      required: true,
    },
    initialGroupName: {
      type: String,
      default: ''
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    editingGroupId: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      trainees: [],
      selectedTrainees: [],
      instructorId: parseInt(localStorage.getItem('user_id')),
      projectId: parseInt(localStorage.getItem('projectId')),
      columns: [
        { label: 'ID', field: 'user_id', sortable: true, thClass: 'vgt-id-column', tdClass: 'vgt-id-column' },
        { label: 'First Name', field: 'first_name', sortable: true, thClass: 'vgt-first-name-column', tdClass: 'vgt-first-name-column' },
        { label: 'Last Name', field: 'last_name', sortable: true, thClass: 'vgt-last-name-column', tdClass: 'vgt-last-name-column' },
        { label: 'Email', field: 'email', sortable: true, thClass: 'vgt-email-column', tdClass: 'vgt-email-column' },
        { label: 'Select Trainee', field: 'select', sortable: false, type: 'html', thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' },
      ],
      perPage: 50,
      isVisible: false,
      selectAll: false,
      groupName: '',
    };
  },
  computed: {
    filteredTrainees() {
      return this.trainees;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    selectAllTrainees() {
      const ids = this.trainees.map(t => t.user_id);
      this.selectedTrainees = Array.from(new Set([...this.selectedTrainees, ...ids]));
    },

    clearSelection() {
      this.selectedTrainees = [];
    },
    isDuplicateGroup(selectedIds) {
      const selectedSorted = [...selectedIds].sort((a, b) => a - b);

      return this.propGroups.find(group => {
        const groupTraineeIds = group.trainees.map(t => t.user_id || t);
        if (groupTraineeIds.length !== selectedSorted.length) return false;

        const groupSorted = [...groupTraineeIds].sort((a, b) => a - b);

        return JSON.stringify(groupSorted) === JSON.stringify(selectedSorted);
      }) || null;
    },
    toggleCheckbox(userId) {
      const index = this.selectedTrainees.indexOf(userId);
      if (index > -1) {
        this.selectedTrainees.splice(index, 1);
      } else {
        this.selectedTrainees.push(userId);
      }
    },
    cancelConfirmation() {
      this.showConfirmationModal = false;
      this.groupName = '';
    },
    async confirmSelectionWithGroup() {
      if (this.selectedTrainees.length === 0) {
        alert('Please select at least one trainee.');
        return;
      }

      if (!this.groupName.trim()) {
        alert('Please enter a group name.');
        return;
      }

      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        if (this.isEditing && this.editingGroupId) {
          const updateResponse = await axios.put(`/api/groups/${this.editingGroupId}/update-trainees`, {
            name: this.groupName,
            trainee_ids: this.selectedTrainees
          }, { headers });

          if (updateResponse.status === 200) {
            alert('Group updated successfully!');
          }
        } else {
          const response = await axios.post('/api/groups', {
            instructor_id: this.instructorId,
            project_id: this.projectId,
            name: this.groupName,
          }, { headers });

          const groupId = response.data.group_id;

          const addResponse = await axios.post(`/api/groups/${groupId}/add-trainees`, {
            trainee_ids: this.selectedTrainees,
          }, { headers });

          if (response.status === 201 && addResponse.status === 200) {
            alert('Group created successfully!');
          }
        }

        const selected = this.trainees.filter(t => this.selectedTrainees.includes(t.user_id));
        this.$emit('confirm', selected);
        this.close();

      } catch (error) {
        console.error(error);
        alert(this.isEditing ? 'Failed to update group.' : 'Failed to create group.');
      }
    },
  }, async mounted() {
    this.isVisible = true;
    this.trainees = this.propTrainees;
    // Extract user_ids from initialSelected and assign them
    this.selectedTrainees = this.initialSelected;
    this.groupName = this.initialGroupName;
    this.totalPages = Math.ceil(this.trainees.length / this.perPage);
  }
};
</script>

<style scoped>
.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.confirm-button,
.cancel-button {
  padding: 10px 15px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-button {
  background-color: #28a745;
  color: white;
}

.cancel-button {
  background-color: #dc3545;
  color: white;
}

.trainee-table {
  width: 100%;
  border-collapse: collapse;
}

.trainee-table th,
.trainee-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.trainee-table th {
  background-color: #f4f4f4;
}

.Trainee-modal-overlay {
  position: fixed;
  top: 0px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 12;
}

.Trainee-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  max-width: 90vw;
  max-height: 94vh;
  min-width: max(60vw, 1000px);
  padding: 10px;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1004;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
}

.modal-title {
  text-align: center;
  margin-bottom: 20px;
}

.assessment-table {
  width: 90%;
  border-collapse: collapse;
  align-items: center;
  margin: 0 auto;
}

.assessment-table th,
.assessment-table td {
  border: 1px solid #ddd;
  padding: 3px;
  text-align: left;
  font-size: 14px;
}

.assessment-table thead th {
  background-color: #f2f2f2;
  font-size: 15px;
}

.signature-section {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.signature-item label {
  width: 40%;
  display: block;
  margin-bottom: 5px;
}

.signature-placeholder,
.date-placeholder {
  border: 1px solid #ddd;
  padding: 5px;
  min-height: 30px;
  /* Adjust as needed */
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin: 0px;
  margin-top: 20px;
}

.ins-save-button {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  width: 100%;
  min-width: 90px;
  max-width: 100px;
}

.ins-submit-button {
  background-color: brown;
  border: 1px solid rgb(92, 23, 23);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  min-width: 100px;
  max-width: 120px;
  margin-right: 5%;
  height: 35px;
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 5%;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.ins-clear-button {
  background-color: #f0ac9c;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 0;
  width: 100%;
  min-width: 140px;
  max-width: 150px;
  border: 1px solid #c7715e;
}

.ins-save-button:disabled,
.ins-submit-button:disabled,
.ins-clear-button:disabled {
  background-color: rgb(216, 216, 216);
  cursor: not-allowed;
  color: grey
}

.ins-save-button:disabled:hover,
.ins-submit-button:disabled:hover,
.ins-clear-button:disabled:hover {
  background-color: rgb(216, 216, 216);
  color: grey
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.assessment-result {
  margin-left: 25%;
}

.task-performance {
  width: 50%;
  border-collapse: collapse;
  text-align: left;
  background-color: #f2f2f2;
  margin-left: 20px;
}

.task-performance th {
  /* Adjust the color to match your header background */
  font-weight: bold;
}


.task-performance input[type="text"] {
  width: 100%;
  border: none;
  padding: 4px;
  text-align: center;
  background-color: #f2f2f2;
}

.assessment-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
}


.signature-block {
  display: flex;
  flex-direction: column;
  margin-right: 70px;
}


.signature-table {
  width: 100%;
}

.signature-table td {
  padding: 4px;
  /* Adjust padding as needed */
  vertical-align: middle;
  /* Aligns content of <td> vertically in the middle */
}

.signature-table .signature {
  text-align: left;
  /* Aligns the text to the left */
}

.trainee-signature {
  text-align: left;
}

.signature-table input[type="text"],
.signature-table input[type="date"] {
  width: 100%;
  border: none;
  border-bottom: 1px solid black;
  border-radius: 0px;
  background-color: transparent;
  outline: none;
  height: 20px;
}

@media (max-width: 768px) {

  /* Adjust the max-width as needed for iPad or other tablet sizes */
  .Evaluation-modal {
    padding: 5px;
    font-size: 0.9em;
    /* Reduce font size */
  }

  /* Further adjustments for other elements */
}


#selectAllSatisfactory {
  margin-left: 5px;
  border: 1px solid rgb(206, 13, 13);
}

.signature-pad {
  border-bottom: 1px solid #000;
  border-radius: 5px;
}

.right {
  display: flex;
  justify-content: flex-end;
  margin-right: 5%;
}

/* Add this CSS to your stylesheet */
.signature-image-wrapper {
  position: relative;
  display: inline-block;
}

.signature-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none;
  /* Prevents interaction with the overlay */
}

.disabled {
  opacity: 0.5;
  /* Optionally reduce opacity to indicate disabled state */
}

.missing-task {
  background-color: #fce2e4;
  /* Light red background for missing tasks */
}

span:hover {
  cursor: pointer;
  color: blue;
}

.pagination-container {
  display: flex;
  margin-left: 3%;

}

.container-fluid {
  padding-top: 5px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.search-container {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  font-size: 16px;
  width: 80%;
}

button.btn {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 40px;
  margin-top: 0%;
  margin-bottom: 0px;
  border: 1px solid rgb(0, 45, 63);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
  margin-right: 30px;
}

button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

.heading h1 {
  padding-top: 30px;
  padding-bottom: 10px;
  text-align: center;
  padding-left: 3%;

}

.back-button {
  /* Adjust the right position as needed */
  width: 100px;
  border-radius: 5px;
  background-color: #c1e0bf;
  float: left;
  margin-left: 30px;
  border: 2px solid black;
  padding: 3px;
}

button:hover {
  background-color: #7c927a;
  transition: transform 0.2s, box-shadow 0.2s;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.pagination-info {
  font-size: 14px;
  color: #666;
  text-align: center;
  width: 100%;
  display: block;
  margin-top: -30px;
  margin-bottom: 10px;
}

/* Data table styles */
.data-table-trainee {
  width: 99%;
  margin-left: 0.5%;
  margin-right: 0.5%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  margin-top: 0;
  align-items: left;
  margin-bottom: 30px;
}

.data-table-trainee th {
  border: 1px solid #000000bf;
  padding: 10px 5px;
  text-align: left;
  color: rgb(107, 107, 107);
  background-color: rgba(219, 219, 219, 0.804);
  margin-top: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
}

.data-table-trainee tbody tr:nth-child(odd) {
  background-color: white;
}

.data-table-trainee tbody tr:nth-child(even) {
  background-color: rgba(219, 219, 219, 0.804);
}


.data-table-trainee td {
  border: 1px solid #000000bf;
  padding: 10px 5px;
  text-align: left;
  font-weight: 500;
  margin-top: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
}

.data-table-trainee,
.data-table-trainee th,
.data-table-trainee td {
  border: 1px solid black;
}

.data-table-trainee th,
.data-table-trainee td {
  padding: 8px;
}

.data-table-trainee td.center-icons {
  text-align: center;
}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  /* Red color */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.delete-icon:hover {
  color: #a82222;
  /* Lighter red color on hover */
  cursor: pointer;
  transform: scale(1.1);
  /* Scale the icon on hover */
  /* You can also add a box-shadow or any other styles you prefer */
}

.save-button {
  background-color: #007bff;
  color: white;
  border: 1px solid #0157b3;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  width: 100%;
  min-width: 90px;
  max-width: 100px;
}

.save-button:hover {
  background-color: #0462c7;
}

.submit-button {
  background-color: brown;
  border: 1px solid rgb(99, 15, 15);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 20px;
  min-width: 100px;
  max-width: 120px;
}

.submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.cancel-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
}

.cancel-button:hover {
  background-color: #545a5f;
}

.clear-button {
  background-color: #ee9581;
  color: white;
  font-size: 14px;
  border-radius: 5px;
  margin-left: 20px;
  width: 100%;
  min-width: 60px;
  max-width: 100px;
  border: 1px solid #c7715e;
  height: 30px;
  padding: 0px;
}

.clear-button:hover {
  background-color: #e47a62;
}

.small-modal {
  max-width: 900px;
  /* Smaller width */
  min-width: 700px;
  max-height: 90vh;
  /* Limit height */
  overflow-y: auto;
  padding: 15px;
  border-radius: 8px;
}

.group-name-container {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}

input#groupName {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
}

.action-bar {
  display: flex;
  justify-content: flex-end;
}

.multi-sign-off-button {
  font-size: 15px;
  border-radius: 5px;
  margin-right: 20px;
  width: 140px;
  height: 40px;
  border: 1px solid grey;
}

.multi-sign-off-button:hover {
  background-color: #bbbaba;
}
</style>